//#region IMPORTS
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { Order } from "../../models/order";
//#endregion

//#region INTERFACE
interface Props {
  picklistHandler: () => void;
  hide?: boolean;
  order: Order;
}
//#endregion

export default function OrdersTableRowActionPicklist({
  picklistHandler,
  order,
  hide = false,
}: Props) {
  //#region RENDER
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Request list?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(order.id) + "picklist"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <DocumentArrowDownIcon
          className="h-5 w-5 text-emerald-700 hover:cursor-pointer hover:text-emerald-500"
          onClick={picklistHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(order.id) + "picklist"} />
    </Fragment>
  ) : null;
  //#endregion
}
